<template>
    <!-- banner -->
    <section class="topBlock">
        <div class="banner oneBanner proBanner">
            <el-carousel height="460px" :autoplay="false" arrow="never">
                <el-carousel-item>
                    <div class="container">
                        <div class="bannerLink">
                            <h3>项目服务</h3>
                            <p>泰迪服务商竭诚为您提供优质服务</p>
                            <router-link to="/projectApplication"><a class="btn bigBtn whiteSty" href="#">申请服务</a></router-link>
                        </div>
                        <div class="img"><img src="@/pages/frontend/assets/images/banner_project.png"></div>
                    </div>
                </el-carousel-item>
            </el-carousel>

<!--             <ul class="imgList">
                <li>
                    <a>
                        <div class="container">
                            <img src="@/pages/frontend/assets/images/banner_project.png">
                        </div>
                    </a>
                </li>
            </ul> -->
        </div>

        <!-- 查询 -->
        <!-- <div class="bannerLink">
            <h3>数据项目服务</h3>
            <p>泰迪服务商竭诚为您提供优质服务</p>
            <router-link to="/projectApplication"><a class="btn bigBtn whiteSty" href="#">申请服务</a></router-link>
            <a class="btn bigBtn whiteLineSty" href="#">立即咨询</a>
        </div> -->

        <!-- 会员中心 -->
        <!-- <div class="uCenter">
            <div class="info">
                <div class="userImg">
                    <img src="@/pages/frontend/assets/images/headIcons.png">
                </div>
                <div class="userName">
                    <div class="name"><span>泰迪智能科技</span><i class="icon-vip"></i></div>
                    <p>下午好，欢迎回来！</p>
                </div>
            </div>
            <div class="msg">
                <a>
                    <h3>项目需求</h3>
                    <p><span>02</span>个</p>
                </a>
                <a>
                    <h3>项目进度</h3>
                    <p><span>50</span>%</p>
                </a>
            </div>
            <div class="notices">
                <ul>
                    <li><a>系统通知：您的人才需求审核通过才能正常使用</a></li>
                    <li><a>系统通知：平台升级啦，查看新功能</a></li>
                </ul>
            </div>
            <a class="btn bigBtn blueSty ucLink" href="#">个人中心</a>
        </div> -->
    </section>
</template>
<script>
    export default {

    }
</script>